import { render } from "./TocTable.vue?vue&type=template&id=e8db266a&scoped=true"
import script from "./TocTable.vue?vue&type=script&lang=js"
export * from "./TocTable.vue?vue&type=script&lang=js"

import "./TocTable.vue?vue&type=style&index=0&id=e8db266a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8db266a"]])

export default __exports__